import Divider from '@mui/material/Divider';
import type { GridProps } from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import type { JSX, ReactNode } from 'react';
import { PageSection } from '../PageSection/PageSection.tsx';

interface HistoryContainerProps {
  children?: ReactNode;
  drawerMode?: boolean;
  title: string;
  divider?: boolean;
  status?: string;
  titleSize?: GridProps['size'];
  description?: string | ReactNode;
}

export function HistoryContainer({
  children,
  drawerMode,
  title,
  divider,
  status,
  titleSize,
  description,
}: HistoryContainerProps): JSX.Element {
  if (drawerMode) {
    return (
      <div data-test={title.toLowerCase().replace(/\s/g, '-')}>
        <Typography
          data-test="title"
          variant="h2"
          sx={{
            mb: 1.5,
          }}
        >
          {title}
        </Typography>
        {children}
        {divider && <Divider style={{ margin: '32px 0' }} />}
      </div>
    );
  }

  return (
    <PageSection title={title} divider={divider} status={status} titleSize={titleSize} description={description}>
      {children}
    </PageSection>
  );
}
